import React, { useState } from "react";
import { styles } from "./readMore.style";

const ReadMore = ({ children = "", limit = 150 }) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  const showContent =
    isReadMore && children.length > limit
      ? children.slice(0, limit) + "..."
      : children;

  return (
    <div style={styles.text}>
      <span dangerouslySetInnerHTML={createMarkup(showContent)} />
      {children.length > limit && (
        <span onClick={toggleReadMore} style={styles.read_or_hide}>
          {isReadMore ? "▼ Leggi tutto" : "▲ Leggi meno"}
        </span>
      )}
    </div>
  );
};

export default ReadMore;
